<template>
    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full tw-mb-6">
        <input type="text" class="tw-p-4 tw-bg-blue-0 tw-border-2 tw-border-gray-100 tw-mt-4 tw-text-gray-600" :id="question.id" :value="answer" @input="updateAnswer($event.target.value)" :placeholder="translations['quiz.free_form']">
        <p v-if="exact_answer !== '0'" class="tw-text-sm tw-text-gray-300 tw-mt-4">{{ translations['quiz.answer_must_be_exact'] }}</p>
    </div>

</template>

<script>
    import {mapState} from 'vuex';
    import Global from '../../../mixins/Global.js';

    export default {
        mixins: [Global],
        name: "FreeForm",

        props: ['question', 'exact_answer'],

        computed: {
            ...mapState('quiz',
                ['new_answer']
            ),

            answer: {
                get() {
                    let answer = this.$store.getters['quiz/getQuestionProgress'](this.question.id);

                    if(typeof answer !== "undefined") {
                        return answer.value;
                    }

                    return this.new_answer.value;
                },

                set(value) {
                    let answer = this.$store.getters['quiz/getQuestionProgress'](this.question.id);

                    if(typeof answer !== "undefined") {
                        answer.value = value;
                    } else {
                        this.$store.commit('quiz/setNewAnswer', {value: value, type: this.question.type});
                    }

					this.$store.commit('quiz/setCurrentAnswer', value);
                }
            }
        },

        data() {
            return {
                question_answer: [],
                answers:[],
            }
        },

        methods: {
            updateAnswer(val) {
                this.answer = val;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .quiz-wrapper {
        input {
            max-width: 80%;

            &:focus {
                @apply tw-border-gray-200;
            }

            &::placeholder {
                @apply tw-text-gray-400;
            }
        }
    }
</style>